import React from "react";
import { motion } from "framer-motion";
import { Star, ExternalLink } from "lucide-react";
import googleLogo from "../../assets/partner/google.svg";

const reviews = [
    {
        name: "Vincenzo S.",
        date: "Giugno 2025",
        rating: 5,
        text: "Esperienza eccellente. Mi congratulo con Gianmarco, il proprietario, e tutto lo staff per la gentilezza, serietà e disponibilità. Le pizze sono eccezionali, leggere e cotte alla perfezione, con ingredienti freschi e selezionati. Il menù offre tantissime proposte, ricche di sapore. Ce n’è davvero per tutti i gusti! Consigliatissimo per serate con amici.",
    },
    {
        name: "Fernanda",
        date: "Maggio 2025",
        rating: 5,
        text: "L'impasto della pizza è il migliore in assoluto nel raggio di 20 km. La salsa è ottima. Con questa base danno sempre il meglio. Tutti ragazzi giovani, molto gentili ed estremamente professionali e, come se non bastasse, i prezzi sono ottimi. Da non perdere!",
    },
    {
        name: "Antonio C.",
        date: "Maggio 2024",
        rating: 5,
        text: "Personale gentilissimo e pizza eccellente. Molto leggera e con ingredienti di massima qualità. Anche gli antipasti sono sfiziosi, noi abbiamo preso un tagliere veramente buono. Complimenti, lo consiglio vivamente.",
    },
];

export default function CustomerReviews() {
    return (
        <section className="bg-[#090D16] px-6 py-24 text-center max-w-5xl mx-auto relative border-t border-accent/10">
            {/* Soft Glow di sfondo */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-primary/5 rounded-full blur-[100px] pointer-events-none" />

            <div className="space-y-2 mb-16 relative z-10">
                <span className="text-primary text-xs font-black tracking-widest uppercase block">La Riprova Sociale</span>
                <h2 className="text-3xl md:text-4xl font-title text-secondary tracking-tight">
                    Cosa dicono i nostri ospiti
                </h2>
                <div className="w-10 h-[2px] bg-primary/60 rounded-full mx-auto pt-[2px]" />
            </div>

            {/* Griglia con altezza uniforme forzata */}
            <div className="grid gap-6 md:grid-cols-3 relative z-10 items-stretch">
                {reviews.map((review, idx) => (
                    <motion.div
                        key={idx}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: idx * 0.15, duration: 0.5, ease: "easeOut" }}
                        className="bg-[#0D121F] border border-accent/20 p-6 md:p-8 rounded-3xl text-left shadow-xl hover:border-primary/30 hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)] transition-all duration-300 flex flex-col justify-between group"
                    >
                        <div>
                            {/* Stelle di Valutazione */}
                            <div className="flex items-center gap-1 mb-4">
                                {Array.from({ length: review.rating }).map((_, i) => (
                                    <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400 drop-shadow-[0_0_6px_rgba(251,191,36,0.4)]" />
                                ))}
                            </div>
                            
                            {/* Testo Recensione */}
                            <p className="text-muted text-sm leading-relaxed mb-6 italic text-opacity-90">
                                "{review.text}"
                            </p>
                        </div>

                        {/* Autore e Data fissati sul fondo della card */}
                        <div className="text-[11px] text-muted/60 border-t border-accent/10 pt-4 mt-auto flex justify-between items-center">
                            <div>
                                <strong className="text-secondary block font-semibold not-italic">{review.name}</strong>
                                <span>Recensione Google</span>
                            </div>
                            <span className="font-medium">{review.date}</span>
                        </div>
                    </motion.div>
                ))}
            </div>

            {/* Link Esterno Premium a Google Reviews */}
            <motion.div 
                className="mt-16 inline-flex relative z-10"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4 }}
            >
                <a
                    href="https://www.google.com/search?sa=X&sca_esv=301c2d72a545a3fe&tbm=lcl&sxsrf=AE3TifPU6c-n9eSeXMJXho_gER9IsMrPnw:1751294779600&q=Pizzeria+Il+Balconcino+Food+%26+Beer+Recensioni&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDG1MDE2MbYwMjM2trC0MDAwMN_AyPiKUTcgs6oqtSgzUcEzR8EpMSc5Py85My9fwS0_P0VBTcEpNbVIISg1OTWvODM_L3MRK2nqAbDEH257AAAA&rldimm=14584343826338980007&hl=it-IT&ved=2ahUKEwiYsvC5sZmOAxV2nf0HHZATC9kQ9fQKegQIVBAF&biw=1920&bih=934&dpr=1#lkt=LocalPoiReviews"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-3 bg-[#0D121F] border border-accent/30 hover:border-primary/40 px-6 py-3 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 group"
                >
                    <img src={googleLogo} alt="Google" className="h-4 opacity-80 group-hover:opacity-100 transition-opacity" draggable={false} />
                    <span className="text-muted text-xs font-bold tracking-wide group-hover:text-primary transition-colors flex items-center gap-1.5">
                        Leggi tutte le recensioni 
                        <ExternalLink className="w-3 h-3 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                    </span>
                </a>
            </motion.div>
        </section>
    );
}